import React from "react";
import { useEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import isEmpty from "lodash/isEmpty";

import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import DateRange from "../../components/ServiceRequests/Facilitator/DateRange";
import useDebouncedEffect from "../../hoc/useDebouncedEffect";
import { useTable } from "react-table";
import { set, result, filter } from "lodash";
import CustomerFilter from "../../components/ServiceRequests/Facilitator/CustomerFilter";
import SelectDropdownFilter from "../../components/ServiceRequests/Facilitator/SelectDropdownFilter";
import ContainerActions from "../../components/ServiceRequests/Facilitator/ContainerActions";
import FacilitatorActionsTable from "../../components/ServiceRequests/Facilitator/FacilitatorActionsTable";
import Spinner from "../../common/Spinner/Spinner";
import moment from "moment";

export default function FacilitatorActionsViewContainer(props) {
	const history = useHistory();

	const [isLoading, setIsLoading] = useState(false);
	const [tableInstance, setTableInstance] = useState(null);

	const [facilitatorActionsList, setFacilitatorActionsList] = useState([]);
	const [
		selectedFacilitatorAction,
		setSelectedFacilitatorAction,
	] = useState();
	const [pages, setPages] = useState(0);
	const PAGE_SIZE = 10;
	const onSelectFacilitatorAction = (e) => {
		setSelectedFacilitatorAction(e);
	};
	const getFacilitatorActions = async (instance = null) => {
		if (!instance) return;
		if (!tableInstance) setTableInstance(instance);
		if (!getUser()) {
			history.push("/login");
		}
		let page = 0;
		let sortParams = null;
		if (instance.state.sorted.length > 0) {
			const { id, desc } = instance.state.sorted[0];
			sortParams = { column: id, desc };
		}

		if (instance && instance.state) {
			page = instance.state.page;
		}
		let toDateAdjusted = new Date(toDate);
		if (toDate) {
			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		let customerSearchFilter = {};
		setIsLoading(true);
		await api
			.getAllServiceActions(
				page + 1,
				sortParams,
				dateFilter,
				fromDate,
				toDateAdjusted,
				customerFilterValue,
				customerFilter,
				showIncompleteActions
			)
			.then(({ data }) => {
				let count = data.count;
				const totalPages = (count - 1) / PAGE_SIZE + 1;
				setPages(Math.floor(totalPages));
				let sortedArray = []
				if (sortParams === null || sortParams["column"] === "dtFollowupOn") {
					if (sortParams === null || sortParams["desc"] === true) {
						sortedArray = data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD")).reverse()
					}
					else if (sortParams["desc"] === false) {
						sortedArray = data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD"))
					}
				}
				else {
					sortedArray = data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD")).reverse()
				}
				setFacilitatorActionsList(sortedArray);

			});
		setIsLoading(false);
	};

	/**
	 * Date range consts and call backs
	 *
	 */

	const [fromDate, setFromDate] = useState();
	const [toDate, setToDate] = useState();
	const [dateRangeOption, setDateRangeOptions] = useState([
		{
			value: "dtFollowupOn",
			label: "Followup On",
		},
		{
			value: "dtCreated",
			label: "Creation Date",
		},
		{
			value: "dtUpdated",
			label: "Updation Date",
		},
	]);
	const onDateRangeChange = (dateLable, dateValue) => {
		if (dateLable === "fromDate") {
			setFromDate(dateValue);
		}
		if (dateLable === "toDate") {
			setToDate(dateValue);
		}
	};
	const [dateFilter, setDateFilter] = useState({
		value: "dtFollowupOn",
		label: "Followup On",
	});
	const onDateFilterChange = (e) => {
		setDateFilter(e);
	};
	/**
	 *
	 */

	/**
	 * Customer filter
	 */

	const onSearchClicked = () => {
		getFacilitatorActions(tableInstance);
	};
	const [customerFilterOptions, setCustomerFilterOptions] = useState([
		{
			value: "name",
			label: "Customer Name",
		},
		{
			value: "email_id",
			label: "Customer Email",
		},
	]);
	const [customerFilter, setCustomerFilter] = useState();

	const onCustomerFilterChange = (e) => {
		setCustomerFilter(e);
	};
	const [customerFilterValue, setCustomerFilterValue] = useState();
	const onCustomerFilterValueChange = (e) => {
		setCustomerFilterValue(e.target.value);
	};

	/** */
	/**Handled checkbox */
	const [showIncompleteActions, setShowIncompleteActions] = useState(true);
	const toggleShowIncompleteActions = (_) => {
		setShowIncompleteActions(!showIncompleteActions);
	};

	/** */
	/** notes modal */
	const [showNotesModal, setShowNotesModal] = useState(false);

	const toggleNotesModal = () => {
		setShowNotesModal(!showNotesModal);
	};
	const onNotesChange = (name, value) => {
		const updated = {
			...selectedFacilitatorAction,
			[name]: value,
		};
		setSelectedFacilitatorAction(updated);
	};
	const onSaveSelectedFacilitatorAction = async () => {
		if (
			selectedFacilitatorAction["sNotes"] === "" ||
			selectedFacilitatorAction["sNotes"] === undefined ||
			selectedFacilitatorAction["sNotes"] === null
		) {
			toast("Notes field is mandetory", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			!(
				selectedFacilitatorAction["dtFollowupOn"] &&
				selectedFacilitatorAction["sFollowupAction"]
			)
		) {
			if (
				(selectedFacilitatorAction["sFollowupAction"] === "" ||
					selectedFacilitatorAction["sFollowupAction"] === null ||
					selectedFacilitatorAction["sFollowupAction"] ===
					undefined) &&
				(selectedFacilitatorAction["dtFollowupOn"] === "" ||
					selectedFacilitatorAction["dtFollowupOn"] === undefined ||
					selectedFacilitatorAction["dtFollowupOn"] === null)
			) {
			} else if (
				selectedFacilitatorAction["dtFollowupOn"] === "" ||
				selectedFacilitatorAction["dtFollowupOn"] === undefined ||
				selectedFacilitatorAction["dtFollowupOn"] === null
			) {
				toast("Followup Date is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else if (
				selectedFacilitatorAction["sFollowupAction"] === "" ||
				selectedFacilitatorAction["sFollowupAction"] === undefined ||
				selectedFacilitatorAction["sFollowupAction"] === null
			) {
				toast("Followup Action is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else {
			}
		}

		try {
			if (true) {
				let data = await api
					.updateNotes({
						id: selectedFacilitatorAction.id,
						bHandled: selectedFacilitatorAction.bHandled,
						dtFollowupOn: selectedFacilitatorAction.dtFollowupOn,
						sFollowupAction:
							selectedFacilitatorAction.sFollowupAction,
						sNotes: selectedFacilitatorAction.sNotes,
						nResourceInstanceId:
							selectedFacilitatorAction["refService"][
							"nResourceInstanceId"
							],
					})
					.then(() => {
						toggleNotesModal();
						getFacilitatorActions(tableInstance);
					});

				setSelectedFacilitatorAction(null);
			}

			toast("Note saved successfully.", {
				autoClose: 5000,
				type: toast.TYPE.SUCCESS,
			});
		} catch (error) {
			toast(String(error.response.statusText), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const [
		showConfirmationModalNotes,
		setShowConfirmationModalNotes,
	] = useState(false);

	const toggleConfirmationModalNotes = () => {
		setShowConfirmationModalNotes(!showConfirmationModalNotes);
	};
	const confirmChangeNotes = () => {
		// setSelectedServiceRequest("");
		// setselectedFacilitatorAction({});
		// setNotesModalVisibility(!showNotesModal);
		// toggleConfirmationModalNotes();
		// setCurrentNote({});
	};
	/** */

	useEffect(() => {
		getFacilitatorActions(tableInstance);
	}, []);
	// useDebouncedEffect(
	// 	() => {
	// 		getFacilitatorActions(tableInstance);
	// 	},
	// 	2000,
	// 	[
	// 		fromDate,
	// 		toDate,
	// 		customerFilterValue,
	// 		showIncompleteActions,
	// 		tableInstance,
	// 	]
	// );

	return (
		<div className={` ${isLoading && "set-opacity"}`}>
			{isLoading && <Spinner className="center"></Spinner>}
			<div style={{ marginBottom: "12px" }}>
				<ContainerActions
					/**Date Range */
					dateRangeOption={dateRangeOption}
					onDateRangeChange={onDateRangeChange}
					onDateFilterChange={onDateFilterChange}
					dateFilter={dateFilter}
					fromDate={fromDate}
					toDate={toDate}
					/**Customer filters */
					customerFilterOptions={customerFilterOptions}
					onCustomerFilterChange={onCustomerFilterChange}
					customerFilter={customerFilter}
					onCustomerFilterValueChange={onCustomerFilterValueChange}
					onSearchClicked={onSearchClicked}
					customerFilterValue={customerFilterValue}
					/**
					 * Completed
					 */

					showIncompleteActions={showIncompleteActions}
					toggleShowIncompleteActions={toggleShowIncompleteActions}
				></ContainerActions>
			</div>
			<div>
				<FacilitatorActionsTable
					user={getUser()}
					data={facilitatorActionsList}
					selectedFacilitatorAction={selectedFacilitatorAction}
					onSelectFacilitatorAction={onSelectFacilitatorAction}
					onFetchServiceRequests={getFacilitatorActions}
					pages={pages}
					pageSize={PAGE_SIZE}
					/**Notes modal  */
					facilitatorActionView={true}
					//selectedFacilitatorAction={selectedFacilitatorAction}
					showNotesModal={showNotesModal}
					toggleNotesModal={toggleNotesModal}
					onNotesChange={onNotesChange}
					onSaveSelectedFacilitatorAction={
						onSaveSelectedFacilitatorAction
					}
					showConfirmationModalNotes={showConfirmationModalNotes}
					toggleConfirmationModalNotes={toggleConfirmationModalNotes}
					confirmChangeNotes={confirmChangeNotes}
				></FacilitatorActionsTable>
			</div>
		</div>
	);
}
